interface Props {
  message: string;
  /** Libelle du bouton d'action. « Supprimer », « Vider », « Se deconnecter ». */
  action: string;
  /** Rouge pour ce qui detruit, accent pour le reste. */
  danger?: boolean;
  onConfirmer: () => void;
  onAnnuler: () => void;
}

/**
 * Demande de confirmation, en feuille remontant du bas.
 *
 * Remplace window.confirm, qui fonctionnait mais affichait une boite systeme
 * portant l'URL du site — de quoi casser l'illusion d'application installee,
 * justement au moment ou l'on hesite. Meme gabarit que la fiche d'edition :
 * le pouce sait deja ou viser.
 */
export function Confirmation({ message, action, danger, onConfirmer, onAnnuler }: Props) {
  return (
    <div className="voile" onClick={onAnnuler} role="presentation">
      <div
        className="feuille feuille-courte"
        onClick={(e) => e.stopPropagation()}
        role="alertdialog"
        aria-modal="true"
      >
        <div className="feuille-poignee" aria-hidden="true" />
        <p className="question">{message}</p>
        <div className="feuille-actions">
          <button type="button" className="bouton discret" onClick={onAnnuler}>
            Annuler
          </button>
          <button
            type="button"
            className={'bouton ' + (danger ? 'danger' : 'primaire')}
            onClick={onConfirmer}
          >
            {action}
          </button>
        </div>
      </div>
    </div>
  );
}
